var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isOpen
    ? _c("div", { staticClass: "wf-violator-bar", attrs: { role: "alert" } }, [
        _c("div", { staticClass: "wf-violator-bar-indicator" }, [
          _c("div", { staticClass: "badge badge-white badge-pointed" }, [
            _vm._v("\n      " + _vm._s(_vm.badge) + "\n    ")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "wf-violator-bar-body" }, [
          _c(
            "div",
            { staticClass: "wf-violator-bar-content d-inline" },
            [_vm._t("content")],
            2
          ),
          _vm._v(" "),
          _vm.buttonUrl
            ? _c(
                "a",
                {
                  staticClass:
                    "wf-violator-bar-cta-button btn-accent-gray border-white btn",
                  attrs: { href: _vm.buttonUrl }
                },
                [
                  _vm._v("\n      " + _vm._s(_vm.buttonText) + "\n      "),
                  _c("span", {
                    staticClass:
                      "png-icon png-icon-icons-glyph--ko-chevron-right ml-3"
                  })
                ]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "wf-violator-bar-close-button btn",
            attrs: {
              type: "button",
              "data-dismiss": "alert",
              "aria-label": "Close alert"
            },
            on: { click: _vm.dismiss }
          },
          [
            _c("span", {
              staticClass: "png-icon png-icon-icons-symbols--ko-txtclose"
            })
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }